import { ApiClient } from './ApiClient';

export interface ArticleListing {
    HeadLine?: string;
    DefaultImageSRC?: string;
    DefaultImageSRC_alTtext?: string;
    IsMyNewsDeskArt?: boolean;
    NewsDeskImageURL_SmallRef?: string;
    NewsDeskImageSRC_smallRef?: string;
    ThumbnailImage?: string;
    ThumbnailImage_AltText?: string;
    UpdatedDateTime?: string;
    StartPublish?: string;
    TopPreamble?: string;
    LinkURL?: string;
    HideArticleDates?: boolean;
}

export interface CategoryFilter {
    text: string;
    url_text: string;
}

export interface ArticleListingsPageData {
    articleListings: ArticleListing[];
    totalPages: number;
    totalArticleListings: number;  
    relevantCategories: CategoryFilter[];

}

export interface ArticleListingsQueryParams {
    [key: string]: string | number | undefined;
    lang?: string;
    Category?: string;
    Type?: string;
    page?: number;
    q?: string;
    pageID?: string;
}

export class ArticleListingApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/articlelistings');
    }

    public getArticleListings(params: ArticleListingsQueryParams = {}): Promise<ArticleListingsPageData> {
        return this.apiClient.get<ArticleListingsPageData>('pageData', params)
    }
}
// Export a single shared instance
export const articleListingsApi = new ArticleListingApi();